import { type PartialProfile } from "@mg/schemas/src/christo/profile";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";

import { getUserProfile } from "../../services/userProfile";
import { useAppDispatch } from "../hooks";
import { setUserProfile } from "../slices/userProfile";

type UserProfileQueryOptions = {
  enabled?: boolean;
  refetchInterval?: number | false;
  refetchIntervalInBackground?: boolean;
};

export function useCurrentUserProfile(
  options?: UserProfileQueryOptions,
): typeof query & {
  data: PartialProfile | undefined;
} {
  const dispatch = useAppDispatch();

  const query = useQuery({
    queryKey: ["user-profile"],
    queryFn: getUserProfile,
    enabled: options?.enabled,
    refetchInterval: options?.refetchInterval,
    refetchIntervalInBackground: options?.refetchIntervalInBackground,
  });

  useEffect(() => {
    if (query.data != null) {
      dispatch(setUserProfile(query.data));
    }
  }, [query.data, dispatch]);

  return query;
}

export function useAskPunttMentionNotificationsProfile(
  options?: UserProfileQueryOptions,
) {
  return useQuery({
    queryKey: ["user-profile", "ask-puntt-mention-notifications"],
    queryFn: getUserProfile,
    enabled: options?.enabled,
    refetchInterval: options?.refetchInterval,
    refetchIntervalInBackground: options?.refetchIntervalInBackground,
  });
}
